import React from "react";
import { useNavigate } from "react-router-dom";
import ROUTE_PATHS from "../../../utils/routePaths";
import { formatAmount } from "../../../utils/Utils";
import "../css/UnregisteredAircraftTripsTable.css";

const UnregisteredAircraftTripsTable = ({
  aircraftList,
  currentPage,
  itemsPerPage,
}) => {
  const navigate = useNavigate();

  const handleIndexClick = (aircraft) => {
    // Store aircraft ID and arrival airport ID in localStorage instead of URL
    localStorage.setItem("unregisteredAircraftId", aircraft.aircraftRegistrationNumber);
    localStorage.setItem("unregisteredAircraftArrivalAirportId", aircraft.arrivalAirportId);
    navigate(ROUTE_PATHS.UNREGISTERED_AIRCRAFT_TRIPS_DETAILS, {
      state: { listPage: currentPage, detailsPage: 1 },
    });
  };

  return (
    <div className="unregistered-aircraft-trips-table-container">
      <table className="unregistered-aircraft-trips-table">
        <thead>
          <tr>
            <th>No.</th>
            <th>Aircraft Reg. No.</th>
            <th>Total Trips</th>
            <th>Arrival Airport</th>
            <th>Total Landing Fees</th>
          </tr>
        </thead>
        <tbody>
          {aircraftList.map((aircraft, index) => {
            const rowNumber = (currentPage - 1) * itemsPerPage + index + 1;
            return (
              <tr key={aircraft.id || index}>
                <td>
                  <span
                    className="unregistered-aircraft-trips-index-link"
                    onClick={() => handleIndexClick(aircraft)}
                  >
                    {rowNumber}
                  </span>
                </td>
                <td>{aircraft.aircraftRegistrationNumber || "-"}</td>
                <td>{aircraft.totalTrips || 0}</td>
                <td>
                  {aircraft?.icaoArrivalAirport
                    ? `${aircraft?.iataArrivalAirport} (${aircraft?.icaoArrivalAirport})`
                    : aircraft?.iataArrivalAirport}
                </td>
                <td>
                  {aircraft.totalFee
                    ? `BSD ${formatAmount(aircraft.totalFee)}`
                    : "BSD 0.00"}
                </td>
              </tr>
            );
          })}
        </tbody>
      </table>
    </div>
  );
};

export default UnregisteredAircraftTripsTable;
